"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLEditor = void 0;
const react_1 = __importDefault(require("react"));
const Editor_1 = require("./Editor");
const index_1 = require("../state/containers/index");
exports.GraphQLEditor = (props) => {
    return (react_1.default.createElement(index_1.TreesStateProvider, null,
        react_1.default.createElement(index_1.ErrorsStateProvider, null,
            react_1.default.createElement(index_1.NavigationStateProvider, null,
                react_1.default.createElement(index_1.IOStateProvider, null,
                    react_1.default.createElement(index_1.ThemeProvider, null,
                        react_1.default.createElement(Editor_1.Editor, Object.assign({}, props))))))));
};
